module.exports = __webpack_public_path__ + "img/loading-small.f4c73cb3.gif";